import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Button, Text, IconButton, Stack, Icon, Heading, Input, TableContainer, Table, Thead, Tr, Th, Tbody, Td } from '@chakra-ui/react';


import { FaCheck, FaUserLock } from 'react-icons/fa';
import { FiUserX } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';

export default function BlockUserButton() {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            <IconButton
                aria-label="Block User"
                icon={<FiUserX />}
                color={'gray.800'}
                bg={'transparent'}
                fontSize={'xl'}
                rounded={'full'}
                onClick={onOpen}
            />
            <Modal isCentered isOpen={isOpen} onClose={onClose} size={'3xl'}>
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={FaUserLock}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={0}>
                            <Heading fontSize={'xl'}>Block User</Heading>
                        </Stack>
                        <ModalCloseButton rounded={'full'} />
                    </ModalHeader>
                    <ModalBody as={Stack} spacing={4} py={8}>
                        <Text>
                            Are you sure you want to revoke the following user(s) access to
                        </Text>
                        <TableContainer>
                            <Table size='md' border={'1px'} borderColor={'gray.100'}>
                                <Thead>
                                    <Tr>
                                        <Th>
                                            User Name
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    <Tr>
                                        <Td as={Input} type={'text'} placeholder={'Name'} value={'Hamza Sheikh'} rounded={'none'}>
                                            {/* <Input type={'text'} size={'md'} placeholder={'Name'} value={'Hamza Sheikh'} /> */}
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button onClick={onClose} leftIcon={<IoMdClose />}>Close</Button>
                        <Button onClick={onClose} leftIcon={<FaCheck />} colorScheme={'primary'}>Yes</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}